/**
 * React Query hook for completing questionnaire
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { completeQuestionnaire, CompleteQuestionnaireRequest, CompleteQuestionnaireResponse } from '../repository';
import { HttpError } from '../../../shared/httpTypes';

/**
 * Query keys for expat questionnaire
 */
export const expatQueryKeys = {
  all: ['expat'] as const,
  questionnaires: () => [...expatQueryKeys.all, 'questionnaires'] as const,
  questionnaire: (id: string) => [...expatQueryKeys.questionnaires(), id] as const,
  sessions: () => [...expatQueryKeys.all, 'sessions'] as const,
  session: (id: string) => [...expatQueryKeys.sessions(), id] as const,
};

/**
 * Hook for completing questionnaire
 */
export function useCompleteQuestionnaire() {
  const queryClient = useQueryClient();

  return useMutation<CompleteQuestionnaireResponse, HttpError, CompleteQuestionnaireRequest>({
    mutationFn: (request) => completeQuestionnaire(request),
    onSuccess: (result) => {
      console.log('Questionnaire submitted successfully:', result);
      // Invalidate related queries
      queryClient.invalidateQueries({ queryKey: expatQueryKeys.sessions() });
    },
    onError: (error: HttpError) => {
      console.error('Error submitting questionnaire:', error);
    },
  });
}


